<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card title="User List" :key="userListKey">
          <div class="row">
            <div class="col-12 mb-3">
              <button class="btn btn-primary" @click="openNewUserPage">Create new user</button>
            </div>
          </div>

          <ul class="user-list">
            <li v-for="user in userList" :key="user._id" class="user">
              <div class="user__username">{{ user.username }}</div>
              <div class="user__email">{{ user.email }}</div>
              <div class="user__btn">
                <button class="btn btn-sm btn-outline-secondary" @click="openEditUserPage(user._id)">edit</button>
                <button class="btn btn-sm btn-outline-danger ml-2" @click="deleteUser(user._id)">delete</button>
              </div>
            </li>
          </ul>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { FETCH_USERS, USER_DELETE } from '@/store/actions.type'
import Swal from 'sweetalert2'

export default {

  data () {
    return {
      userListKey: 0
    }
  },

  computed: {
    ...mapGetters([
      'userList'
    ]),
  },

  mounted() {
    this.$store.dispatch(FETCH_USERS)
  },

  methods: {
    deleteUser (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(USER_DELETE, id).then(res => {
            if (res.data.error) {
              this.$notify({
                message: res.data.error,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'warning'
              });
            } else {
              this.$notify({
                message: res.data.user.username + ' deleted',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'success'
              });

              this.$store.dispatch(FETCH_USERS).then(() => {
                this.userListKey++
              })
            }
          })
        }
      })
    },

    openEditUserPage (id) {
      this.$router.push('/users/update/' + id)
    },

    openNewUserPage () {
      this.$router.push('/users/new')
    }
  }
};
</script>
<style lang="scss" scoped>
.user-access-list {
  list-style: none;
  padding: 0 16px;

  li {
    label {
      font-size: 14px;
      user-select: none;
    }
  }
}

.user-list {
  list-style: none;
  padding: 0;

  .user {
    align-items: center;
    background: #f8f8f8;
    display: flex;
    padding: 8px 16px;

    &__username {
      font-size: 16px;
    }

    &__email {
      font-size: 14px;
      margin-left: .75em;
      opacity: .7;
    }

    &__btn {
      margin-left: auto;
    }
  }

    > :nth-child(even) {
    background: #e9e9e9;
  }
}
</style>
